import { FeatureFlagKey, FeatureFlags } from "@observe-tech/utils";

const featureFlagsInstance = new FeatureFlags();

export const useFeatureFlag = (flagKey: FeatureFlagKey): boolean =>
  featureFlagsInstance.isFeatureEnabled(flagKey);
